import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ImageCropperModalComponent,
  ImageCropperData
} from './image-cropper-modal.component';

@Injectable({ providedIn: 'root' })
export class ImageCropperService {
  constructor(private dialog: MatDialog) {}

  /**
   * Reads the given image file, opens the cropper modal and resolves with the
   * cropped JPEG File, or null if the user cancelled or the file could not be read.
   */
  open(file: File): Promise<File | null> {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.onload = () => {
        this.dialog
          .open(ImageCropperModalComponent, {
            data: {
              imageDataUrl: reader.result,
              fileName: file.name,
              mimeType: file.type
            } as ImageCropperData,
            disableClose: true,
            maxWidth: 'min(560px, 92vw)',
            width: '100%',
          })
          .afterClosed()
          .subscribe((croppedFile: File | null) => resolve(croppedFile ?? null));
      };
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(file);
    });
  }
}
